import {Link} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {reverse} from 'named-urls';
import React, {useState} from 'react';
import {Link as RouterLink} from 'react-router-dom';
import DetailDialog from '../../../../components/DetailDialog';
import routes from '../../../../routes'

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textAlign: 'center',

    '&:hover': {
      color: theme.palette.secondary.main,
      textDecoration: 'none',
    },
  },

  noLink: {
    color: theme.palette.grey[400],
    textAlign: 'center',
  },

  list: {
    display: 'flex',
    flexDirection: 'column',
    listStyle: 'none',
    margin: 0,
    padding: theme.spacing(2, 1.5),

    '& li': {
      alignItems: 'center',
      display: 'flex',
      fontSize: '1.2em',
      margin: 0,
      padding: 0,
    },

    '& a': {
      padding: theme.spacing(0.5, 2),
    },
  }
}));

const Usage = ({question}) => {
  const classes = useStyles();
  const [display, setDisplay] = useState(false);
  return (
    <>
      {question.usage.length > 0 ? (
      <Link className={classes.link} onClick={() => setDisplay(true)}>
        Used in {question.usage.length} {question.usage.length === 1 ? 'category' : 'categories'}
      </Link>
        ) : (
          <span className={classes.noLink}>Used in no categories</span>
      )}
      <DetailDialog
        title={question.body}
        maxWidth="md"
        open={display}
        onClose={() => setDisplay(false)}
        actions={[
          {label: 'Close', colour: 'primary', onClick: () => setDisplay(false)}
        ]}
      >
        <ul className={classes.list}>
          {question.usage.map(({id, title, type: {id: typeId, title: typeTitle}}, index) => (
            <li key={index}>
              <Link
                as={RouterLink}
                to={reverse(routes.auditTypes.detail, {id: typeId})}
                className={classes.link}
                target="_blank"
              >
                {typeTitle}
              </Link>
              <span>&gt;</span>
              <Link
                as={RouterLink}
                to={reverse(routes.auditTypes.section, {id: typeId, sectionID: id})}
                className={classes.link}
                target="_blank"
              >
                {title}
              </Link>
            </li>
          ))}
        </ul>
      </DetailDialog>
    </>
  )
};

export default Usage;
